import { FC } from 'react'

import { SearchDialogButton, SearchDialogButtonType } from './button'
import { SearchProvider, SearchProviderType } from './context'
import { SearchDialogModal, SearchDialogModalType } from './modal'

const SearchDialog: FC &
  SearchProviderType &
  SearchDialogModalType &
  SearchDialogButtonType = () => <></>

SearchDialog.Provider = SearchProvider
SearchDialog.Modal = SearchDialogModal
SearchDialog.Button = SearchDialogButton

export { SearchDialog }
